import * as React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

export const NewsletterImage = ({ settings }) => {
    const isMobile = useMobileBreakpoint();
    
    // Get the appropriate image based on device
    const imageUrl = isMobile && settings.image_mobile ? settings.image_mobile : settings.image;
    
    // Alignment classes
    const alignmentClass = `flex justify-${settings.content_alignment} items-${settings.content_alignment}`;
    
    if (!imageUrl) {
        return null;
    }
    
    return (
        <div className={`newsletter-signup__image w-full h-full relative ${alignmentClass}`}>
            <div 
                className="h-full w-full absolute top-0 left-0 bg-center bg-cover" 
                style={{ backgroundImage: `url(${imageUrl})` }}
                aria-label="Newsletter image"
            />
        </div>
    );
};

export default NewsletterImage;